import { createFileRoute } from '@tanstack/react-router';
import UserLayout from '@components/layout/UserLayout.tsx';
import UpcomingGoodsPage from '@features/client/dashboard/UpcomingGoodsPage.tsx';

/** Detail za kartou „Co mi dojede" na dashboardu – celý nejbližší závozový den. */
export const Route = createFileRoute('/c/$orgId/$portalId/upcoming-goods/')({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <UserLayout>
      <UpcomingGoodsPage />
    </UserLayout>
  );
}
